import i18next from "i18next";
import MainHeaderCell from "components/common/datatable/MainHeaderCell";
import {cellWithTooltip } from "components/common/datatable/EADataGrid";
import React from "react";
import DataTableActions from "../../../components/common/datatable/DataTableActions";
import moment from "moment";

export const contextInstanceListColumns = (showContextDetail) => {
  return [
    {
      field: "contextModelName",
      headerName: i18next.t("context.dataTable.context"),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell name={i18next.t("context.dataTable.context")} />
      ),
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "reference",
      headerName: i18next.t("context.dataTable.reference"),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell name={i18next.t("context.dataTable.reference")} />
      ),
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "expirationDate",
      headerName: i18next.t("context.dataTable.expirationDate"),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell name={i18next.t("context.dataTable.expirationDate")} />
      ),
      renderCell: (params) => {
        const m = moment(params.value);
        const date = m.isValid()?m.format("DD/MM/YYYY"): i18next.t("context.dataTable.noExpirationDate");
        return cellWithTooltip(date)
      },
    },
    {
      field: "creationDate",
      headerName: i18next.t("context.dataTable.creationDate"),
      flex: 0.1,
      renderHeader: () => (
          <MainHeaderCell name={i18next.t("context.dataTable.creationDate")} />
      ),
      renderCell: (params) => {
        const m = moment(params.value);
        const date = m.isValid()?m.format("DD/MM/YYYY"): i18next.t("context.dataTable.noExpirationDate");
        return cellWithTooltip(date)
      },
    },
    {
      field: 'createdBy',
      headerName: i18next.t(
        'demandes.contextModel.contextModelListColumns.createdBy'
      ),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell
          name={i18next.t(
            'demandes.contextModel.contextModelListColumns.createdBy'
          )}
        />
      ),
      renderCell: (params) =>
        cellWithTooltip(
          <>
            {params.value.nom} {params.value.prenom}
          </>
        ),
    },
    {
      field: "action",
      headerName: i18next.t("actions"),
      flex: 0.1,
      sortable: false,
      filterable: false,
      disableExport: true,
      hideSortIcons: true,
      disableReorder: true,
      disableColumnMenu: true,
      disableMultipleSelection: true,
      disableSelectionOnClick: true,
      isRowSelectable: false,
      hideFooterSelectedRowCount: true,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="dt" style={{ textAlign: "center" }}>
            <DataTableActions
              actions={[
                {
                  label: i18next.t("show"),
                  icon: "modify-action",
                  isDisabled: false,
                  action: () => showContextDetail(params.id),
                }
              ]}
            />
          </div>
        );
      },
    },
  ];
};
